export const showHomeHeader = 'showHomeHeader'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js